import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UserService} from '../services/user/user.service';
import {NavigationService} from '../services/nav/navigation.service';
import {JwtService} from '../services/user/jwt.service';
import {UserDto} from '@api/utisha-backend';
import UserTypeEnum = UserDto.UserTypeEnum;

@Injectable({
  providedIn: 'root'
})
export class HomeGuard {

  constructor(
    private userService: UserService,
    private navService: NavigationService,
    private router: Router,
    private jwt: JwtService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.userService.getUser().catch(() => null);

    const slug = localStorage.getItem('utisha_last_school');

    if (!user) {
      // getUser() failed — user may be visiting a school they're not a member of.
      // Use the JWT's global user-type claim to route them to the right section
      // of whichever school is stored, rather than kicking them to /explore.
      const userType = await this.jwt.getUserType();
      if (!userType || !slug) {
        this.router.navigate(['/explore']);
        return false;
      }
      if (userType === 'TEACHER') {
        this.router.navigate(['/', slug, 'teacher']);
      } else {
        this.router.navigate(['/', slug, 'student']);
      }
      return false;
    }

    if (!slug) {
      this.router.navigate(['/explore']);
      return false;
    }

    // Slug is stored; NavigationService.goto() will prepend it automatically.
    if (user.userType === UserTypeEnum.Teacher) {
      const isAdmin = await this.userService.isAdmin();
      isAdmin ? this.navService.defaultAdminPage() : this.navService.defaultTeacherPage();
    } else {
      this.navService.defaultStudentPage();
    }
    return false;
  }
}
